import { useState } from "react";
import { Eye } from "lucide-react";
import { toast } from "sonner";
import { Btn } from "@/components/Btn";
import { Spinner } from "@/components/Brand";
import { AiNoteActions, NoteHeader } from "@/components/AiNote";
import { aiPost, usePrefs, useSavePrefs } from "@/lib/store";

export function ThemeInsight({ theme, count }) {
  const { data: prefs } = usePrefs();
  const save = useSavePrefs();
  const [loading, setLoading] = useState(false);
  const cached = prefs?.themeInsight?.theme === theme ? prefs.themeInsight : null;
  const stale = cached && cached.n !== count;
  const look = async () => {
    setLoading(true);
    const text = await aiPost("theme-insight", { theme }, "insight");
    if (text) save.mutate({ themeInsight: { theme, n: count, text, at: new Date().toISOString() } });
    else toast.error("Triggerific couldn't look just now — please try again in a moment");
    setLoading(false);
  };
  return (
    <div className="mt-4 rounded-[20px] bg-t-brand3 p-5" data-testid="theme-insight">
      <NoteHeader autoPlay={false} testId="theme-insight-listen" text={loading ? null : cached?.text}
        title={<p className="flex items-center gap-2 font-bold text-t-onbrand3"><Eye size={16} /> What Triggerific notices about “{theme}”</p>} />
      {loading ? <div className="mt-3 flex items-center gap-3 text-t-on2 text-sm"><Spinner className="text-t-brand w-4 h-4" /> Looking gently across your {theme.toLowerCase()} moments…</div>
        : cached ? <p className="mt-3 text-t-on leading-relaxed whitespace-pre-line" data-testid="theme-insight-text">{cached.text}</p>
        : <p className="mt-2 text-sm text-t-on2">Sometimes a pattern is easier to spot from the outside. Triggerific can look across every time this came up and share what it sees.</p>}
      {!loading && cached ? <AiNoteActions text={cached.text} kind="insight" testId="theme-insight" /> : null}
      <Btn size="md" variant={cached ? "secondary" : "primary"} className="mt-3" onClick={look} disabled={loading} testId="theme-insight-button"
        label={cached ? (stale ? "New entries — look again" : "Look again") : "Show me what you notice"} />
    </div>
  );
}
